<template>
<div class="classes">
  <h1 class="title grey--text">场地收入</h1>
  <v-container class="my-5">
    <!-- <v-card flat class="mb-5" v-if="studentInfo.length">
      <v-layout align-center justify-center row wrap class="pa-4 student-details">
        <v-flex xs4 md2>
          <div class="caption grey--text">活动承接人</div>
          <div class="caption">{{ studentInfo[0].student_name }}</div>
        </v-flex>
        <v-flex xs4 md2>
          <div class="caption grey--text">押金</div>
          <div class="caption">{{ studentInfo[0].program }}</div>
        </v-flex>
        <v-flex xs4 md2>
          <div class="caption grey--text">承接人次</div>
          <div class="caption">{{ studentInfo[0].tutor_program }}</div>
        </v-flex>
        <v-flex xs4 md2>
          <div class="caption grey--text">总收益</div>
          <div class="caption">{{ studentInfo[0].organization }}</div>
        </v-flex>
        <v-flex xs4 md2>
          <div class="caption grey--text">鼓励金账户余额</div>
          <div class="caption">{{ studentInfo[0].lesson_quantity }}</div>
        </v-flex>
        <v-flex xs4 md2>
          <div class="caption grey--text">其中押金</div>
          <div class="caption">{{ studentInfo[0].enrollment_status }}</div>
        </v-flex>
      </v-layout>
    </v-card> -->
    <v-layout justify-center class="pa3">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">金额</th>
              <th class="text-left">性质</th>
              <th class="text-left">课程</th>
              <th class="text-left">时间</th>
              <th class="text-left">余额</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in venueMoneyRecords" :key="item.host_money_record_id">
              <td class="caption">{{ item.amountYuan }}</td>
              <td class="caption">{{ item.category }}</td>
              <td class="caption">{{ item.lesson }}</td>
              <td class="caption">{{ item.lessonTime }}</td>
              <td class="caption">{{ item.balanceYuan }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-layout>
  </v-container>
</div>
</template>

<script>
import moment from 'moment'
import ProgramService from '@/services/ProgramService'

export default {
  components: {
  },
  data () {
    return {
      classId: null,
      venueId: null,
      venueMoneyRecords: []
    }
  },
  async mounted () {
    this.hostId = parseInt(this.$store.state.route.params.hostId)
    console.log(`hostId: ${this.hostId}`)
    this.venueMoneyRecords = await this.getHostMoneyRecordsById(this.hostId)
    this.venueMoneyRecords.forEach(venueMoneyRecord => {
      venueMoneyRecord.lessonTime = moment(venueMoneyRecord.lesson_time).format('YYYY-MM-DD(dddd) HH:mm')
      venueMoneyRecord.amountYuan = venueMoneyRecord.amount_fen / 100
      venueMoneyRecord.balanceYuan = venueMoneyRecord.balance_fen / 100
      venueMoneyRecord.paymentYuan = venueMoneyRecord.payment_fen / 100
    })
  },
  methods: {
    async getHostMoneyRecordsById (hostId, limit, offset) {
      console.log('\n#getHostMoneyRecordsById starts ... ')
      console.log('hostId: ', hostId, 'limit: ', limit, 'offset: ', offset)
      const res = await ProgramService.getHostMoneyRecordsById({ hostId, limit, offset })
      console.log('retrieve hostMoneyRecords successful! \nhostMoneyRecords: ', res.data)
      return res.data
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
